/*
 * Request Consultation Metadata
 */
export const REQUEST_CONSULTATION_METADATA_TITLE = `Free Home Building Consultation | Claremore, OK | Cornerstone Homes`;

export const REQUEST_CONSULTATION_METADATA_DESC = `Get a free, no-obligation consultation with Cornerstone Homes in Claremore, OK. Discuss your custom home, renovation, or barn project with Craig Hays — experienced builder serving Rogers County and the Tulsa metro since 2000. We respond within 24 business hours.`;

export const REQUEST_CONSULTATION_METADATA_KEYWORDS = [
  'free home building consultation Oklahoma',
  'custom home builder consultation Claremore',
  'home renovation consultation Claremore OK',
  'meet with home builder Oklahoma',
  'Cornerstone Homes consultation',
  'Craig Hays builder consultation',
  'custom home design consultation',
  'free construction consultation Oklahoma',
  'barn construction consultation Oklahoma',
];

export const FORM_SECTION_ID = 'request-consultation-form';
